export const NAHWU_DICTIONARY = [
  // ============================================
  // KATEGORI: KATA KERJA (FI'IL)
  // ============================================
  {
    id: "fiil_madhi",
    category: "Kata Kerja",
    arabic: "فِعْلٌ مَاضٍ",
    latin: "Fi'il Māḍī",
    title: "Fi'il Madhi",
    level: "Dasar",
    tags: ["kata kerja", "lampau", "mabni"],
    description: "Kata kerja yang menunjukkan suatu pekerjaan atau peristiwa yang telah terjadi pada masa lampau. Fi'il Madhi pada asalnya bersifat mabni, sehingga bentuk akhirnya tidak berubah karena perubahan i'rab.",
    characteristics: [
      "Menunjukkan waktu lampau",
      "Bersifat mabni (harakat tidak berubah)",
      "Biasanya diikuti oleh fa'il"
    ],
    formula: "فَعَلَ (fa'ala) - bentuk dasar 3 huruf",
    example: "خَلَقَ اللَّهُ آدَمَ",
    exampleAnalysis: [
      { word: "خَلَقَ", role: "Fi'il Madhi" },
      { word: "اللَّهُ", role: "Fa'il" },
      { word: "آدَمَ", role: "Maf'ul Bih" }
    ],
    translation: "Allah menciptakan Adam.",
    color: "blue",
    relatedTerms: ["fiil_mudhari", "fiil_amr", "fail"]
  },
  
  {
    id: "fiil_mudhari",
    category: "Kata Kerja",
    arabic: "فِعْلٌ مُضَارِعٌ",
    latin: "Fi'il Muḍāri'",
    title: "Fi'il Mudhari'",
    level: "Dasar",
    tags: ["kata kerja", "sekarang", "masa depan", "mu'rab"],
    description: "Kata kerja yang menunjukkan pekerjaan yang sedang atau akan terjadi. Fi'il Mudhari' bersifat mu'rab (dapat berubah harakatnya).",
    characteristics: [
      "Menunjukkan waktu sekarang atau masa depan",
      "Bersifat mu'rab (dapat berubah i'rab)",
      "Diawali huruf mudhari'ah: أ ن ي ت"
    ],
    formula: "يَفْعَلُ (yaf'alu) - diawali ya/ta/alif/nun",
    example: "يَكْتُبُ الطَّالِبُ الدَّرْسَ",
    exampleAnalysis: [
      { word: "يَكْتُبُ", role: "Fi'il Mudhari'" },
      { word: "الطَّالِبُ", role: "Fa'il" },
      { word: "الدَّرْسَ", role: "Maf'ul Bih" }
    ],
    translation: "Siswa (sedang/akan) menulis pelajaran.",
    color: "green",
    relatedTerms: ["fiil_madhi", "fail", "huruf_nashab"]
  },

  {
    id: "fiil_amr",
    category: "Kata Kerja",
    arabic: "فِعْلُ الْأَمْرِ",
    latin: "Fi'lul Amr",
    title: "Fi'il Amr",
    level: "Dasar",
    tags: ["kata kerja", "perintah", "mabni"],
    description: "Kata kerja perintah yang menunjukkan tuntutan untuk melakukan suatu pekerjaan pada masa yang akan datang.",
    characteristics: [
      "Menunjukkan perintah",
      "Bersifat mabni (sukun/harakat tetap)",
      "Tidak memiliki fa'il yang terlihat (mustatir)"
    ],
    formula: "اِفْعَلْ (if'al) - bentuk perintah",
    example: "اُكْتُبْ دَرْسَكَ",
    exampleAnalysis: [
      { word: "اُكْتُبْ", role: "Fi'il Amr" },
      { word: "دَرْسَكَ", role: "Maf'ul Bih" }
    ],
    translation: "Tulislah pelajaranmu!",
    color: "red",
    relatedTerms: ["fiil_madhi", "fiil_mudhari"]
  },

  // ============================================
  // KATEGORI: MARFU'AT
  // ============================================
  {
    id: "fail",
    category: "Marfu'at",
    arabic: "فَاعِلٌ",
    latin: "Fā'il",
    title: "Fa'il",
    level: "Dasar",
    tags: ["pelaku", "subjek", "marfu"],
    description: "Isim yang menunjukkan pelaku suatu pekerjaan dan datang setelah fi'il. Fa'il selalu berstatus marfu', yang umumnya ditandai dengan harakat dhammah.",
    characteristics: [
      "Menunjukkan pelaku pekerjaan",
      "Selalu marfu' (berharakat dhammah)",
      "Terletak setelah fi'il"
    ],
    formula: "فَعَلَ + فَاعِلٌ (fi'il + fa'il)",
    example: "كَتَبَ الطَّالِبُ الدَّرْسَ",
    exampleAnalysis: [
      { word: "كَتَبَ", role: "Fi'il Madhi" },
      { word: "الطَّالِبُ", role: "Fa'il (marfu')" },
      { word: "الدَّرْسَ", role: "Maf'ul Bih" }
    ],
    translation: "Siswa menulis pelajaran.",
    color: "emerald",
    relatedTerms: ["fiil_madhi", "maful_bih", "naibul_fail"]
  },

  {
    id: "mubtada",
    category: "Marfu'at",
    arabic: "مُبْتَدَأٌ",
    latin: "Mubtada'",
    title: "Mubtada'",
    level: "Dasar",
    tags: ["pokok kalimat", "jumlah ismiyyah", "marfu"],
    description: "Isim marfu' yang berada di awal Jumlah Ismiyyah (kalimat nominal). Mubtada' merupakan pokok pembicaraan dalam kalimat.",
    characteristics: [
      "Isim yang disebut pertama kali",
      "Selalu marfu'",
      "Memerlukan khabar untuk menyempurnakan makna"
    ],
    formula: "مُبْتَدَأٌ + خَبَرٌ (mubtada' + khabar)",
    example: "اللَّهُ غَفُورٌ",
    exampleAnalysis: [
      { word: "اللَّهُ", role: "Mubtada' (marfu')" },
      { word: "غَفُورٌ", role: "Khabar (marfu')" }
    ],
    translation: "Allah Maha Pengampun.",
    color: "emerald",
    relatedTerms: ["khabar", "jumlah_ismiyyah", "ismu_kana"]
  },

  {
    id: "khabar",
    category: "Marfu'at",
    arabic: "خَبَرٌ",
    latin: "Khabar",
    title: "Khabar",
    level: "Dasar",
    tags: ["predikat", "jumlah ismiyyah", "marfu"],
    description: "Bagian kalimat yang menerangkan atau menyempurnakan makna Mubtada'. Khabar juga berstatus marfu'.",
    characteristics: [
      "Menerangkan mubtada'",
      "Selalu marfu'",
      "Dapat berupa isim, jumlah, atau jarr majrur"
    ],
    formula: "مُبْتَدَأٌ + خَبَرٌ",
    example: "الطَّالِبُ مُجْتَهِدٌ",
    exampleAnalysis: [
      { word: "الطَّالِبُ", role: "Mubtada'" },
      { word: "مُجْتَهِدٌ", role: "Khabar (marfu')" }
    ],
    translation: "Siswa itu rajin.",
    color: "emerald",
    relatedTerms: ["mubtada", "khabar_kana"]
  },

  {
    id: "naibul_fail",
    category: "Marfu'at",
    arabic: "نَائِبُ الْفَاعِلِ",
    latin: "Nā'ibul Fā'il",
    title: "Na'ibul Fa'il",
    level: "Menengah",
    tags: ["pengganti fa'il", "pasif", "marfu"],
    description: "Isim yang menggantikan posisi fa'il ketika fa'il tidak disebutkan (kalimat pasif). Na'ibul fa'il selalu marfu'.",
    characteristics: [
      "Menggantikan fa'il yang dihilangkan",
      "Selalu marfu'",
      "Muncul dalam bentuk kalimat pasif"
    ],
    formula: "فُعِلَ + نَائِبُ الْفَاعِلِ",
    example: "خُلِقَ الْإِنْسَانُ",
    exampleAnalysis: [
      { word: "خُلِقَ", role: "Fi'il Madhi Majhul (pasif)" },
      { word: "الْإِنْسَانُ", role: "Na'ibul Fa'il (marfu')" }
    ],
    translation: "Manusia diciptakan.",
    color: "emerald",
    relatedTerms: ["fail", "fiil_madhi"]
  },

  {
    id: "ismu_kana",
    category: "Marfu'at",
    arabic: "اِسْمُ كَانَ",
    latin: "Ismū Kāna",
    title: "Ismu Kana",
    level: "Menengah",
    tags: ["kana wa akhwatuha", "marfu"],
    description: "Isim yang datang setelah kana dan saudara-saudaranya. Ismu kana selalu marfu' (seperti mubtada').",
    characteristics: [
      "Datang setelah kana/khabar",
      "Selalu marfu'",
      "Khabarnya manshub"
    ],
    formula: "كَانَ + اِسْمٌ (marfu') + خَبَرٌ (manshub)",
    example: "كَانَ الطَّالِبُ مُجْتَهِدًا",
    exampleAnalysis: [
      { word: "كَانَ", role: "Kana" },
      { word: "الطَّالِبُ", role: "Ismu Kana (marfu')" },
      { word: "مُجْتَهِدًا", role: "Khabar Kana (manshub)" }
    ],
    translation: "Siswa itu (dahulu) rajin.",
    color: "emerald",
    relatedTerms: ["khabar_kana", "mubtada", "khabar"]
  },

  // ============================================
  // KATEGORI: MANSHUBAT
  // ============================================
  {
    id: "maful_bih",
    category: "Manshubat",
    arabic: "مَفْعُولٌ بِهِ",
    latin: "Maf'ūlun Bih",
    title: "Maf'ul Bih",
    level: "Dasar",
    tags: ["objek", "penderita", "manshub"],
    description: "Isim yang menjadi objek dari suatu pekerjaan. Maf'ul Bih selalu berstatus manshub, yang umumnya ditandai dengan harakat fathah.",
    characteristics: [
      "Menjadi objek pekerjaan",
      "Selalu manshub (berharakat fathah)",
      "Terletak setelah fi'il dan fa'il"
    ],
    formula: "فَعَلَ + فَاعِلٌ + مَفْعُولٌ بِهِ",
    example: "خَلَقَ اللَّهُ آدَمَ",
    exampleAnalysis: [
      { word: "خَلَقَ", role: "Fi'il" },
      { word: "اللَّهُ", role: "Fa'il" },
      { word: "آدَمَ", role: "Maf'ul Bih (manshub)" }
    ],
    translation: "Allah menciptakan Adam.",
    color: "orange",
    relatedTerms: ["fail", "fiil_madhi"]
  },

  {
    id: "khabar_kana",
    category: "Manshubat",
    arabic: "خَبَرُ كَانَ",
    latin: "Khabaru Kāna",
    title: "Khabar Kana",
    level: "Menengah",
    tags: ["kana", "manshub", "predikat"],
    description: "Khabar yang datang setelah kana dan saudara-saudaranya. Khabar kana selalu manshub (berbeda dengan khabar biasa yang marfu').",
    characteristics: [
      "Khabar dari ismu kana",
      "Selalu manshub (fathah)",
      "Menerangkan ismu kana"
    ],
    formula: "كَانَ + اِسْمٌ (marfu') + خَبَرٌ (manshub)",
    example: "كَانَ الْجَوُّ بَارِدًا",
    exampleAnalysis: [
      { word: "كَانَ", role: "Kana" },
      { word: "الْجَوُّ", role: "Ismu Kana (marfu')" },
      { word: "بَارِدًا", role: "Khabar Kana (manshub)" }
    ],
    translation: "Cuaca (dahulu) dingin.",
    color: "orange",
    relatedTerms: ["ismu_kana", "khabar"]
  },

  {
    id: "hal",
    category: "Manshubat",
    arabic: "حَالٌ",
    latin: "Ḥāl",
    title: "Hal",
    level: "Menengah",
    tags: ["keadaan", "manshub"],
    description: "Isim yang menerangkan keadaan fa'il atau maf'ul ketika melakukan pekerjaan. Hal selalu manshub dan bersifat nakirah (indefinite).",
    characteristics: [
      "Menerangkan keadaan",
      "Selalu manshub dan nakirah",
      "Menjawab pertanyaan 'bagaimana'"
    ],
    formula: "فَاعِلٌ + فِعْلٌ + حَالٌ",
    example: "جَاءَ الطَّالِبُ مُسْرِعًا",
    exampleAnalysis: [
      { word: "جَاءَ", role: "Fi'il" },
      { word: "الطَّالِبُ", role: "Fa'il" },
      { word: "مُسْرِعًا", role: "Hal (manshub, nakirah)" }
    ],
    translation: "Siswa datang dengan tergesa-gesa.",
    color: "orange",
    relatedTerms: ["fail", "maful_bih", "tamyiz"]
  },

  {
    id: "tamyiz",
    category: "Manshubat",
    arabic: "تَمْيِيزٌ",
    latin: "Tamyīz",
    title: "Tamyiz",
    level: "Menengah",
    tags: ["penjelas", "manshub"],
    description: "Isim nakirah manshub yang menjelaskan makna yang masih samar (mubham) sebelumnya.",
    characteristics: [
      "Menjelaskan yang mubham",
      "Selalu nakirah dan manshub",
      "Menjawab pertanyaan 'apa maksudnya'"
    ],
    formula: "عَدَدٌ/مُبْهَمٌ + تَمْيِيزٌ",
    example: "اِشْتَرَيْتُ عِشْرِينَ كِتَابًا",
    exampleAnalysis: [
      { word: "اِشْتَرَيْتُ", role: "Fi'il + Fa'il" },
      { word: "عِشْرِينَ", role: "Maf'ul Bih (angka)" },
      { word: "كِتَابًا", role: "Tamyiz (manshub)" }
    ],
    translation: "Aku membeli dua puluh buku.",
    color: "orange",
    relatedTerms: ["hal", "maful_bih"]
  },

  {
    id: "maful_mutlaq",
    category: "Manshubat",
    arabic: "مَفْعُولٌ مُطْلَقٌ",
    latin: "Maf'ūlun Muṭlaq",
    title: "Maf'ul Mutlaq",
    level: "Menengah",
    tags: ["penguatan", "manshub"],
    description: "Mashdar yang berasal dari fi'il dalam kalimat untuk menguatkan makna fi'il atau menunjukkan bilangan/jenis.",
    characteristics: [
      "Berasal dari fi'il yang sama",
      "Selalu manshub",
      "Menguatkan makna fi'il"
    ],
    formula: "فَعَلَ + مَصْدَرٌ manshub",
    example: "ضَرَبْتُهُ ضَرْبًا",
    exampleAnalysis: [
      { word: "ضَرَبْتُهُ", role: "Fi'il + Fa'il + Maf'ul" },
      { word: "ضَرْبًا", role: "Maf'ul Mutlaq (manshub)" }
    ],
    translation: "Aku memukulnya dengan pukulan.",
    color: "orange",
    relatedTerms: ["maful_bih", "mashdar"]
  },

  {
    id: "maful_liajlih",
    category: "Manshubat",
    arabic: "مَفْعُولٌ لِأَجْلِهِ",
    latin: "Maf'ūlun Li'ajlih",
    title: "Maf'ul Li'ajlih",
    level: "Lanjutan",
    tags: ["sebab", "manshub"],
    description: "Mashdar manshub yang menunjukkan sebab atau alasan terjadinya suatu pekerjaan.",
    characteristics: [
      "Menunjukkan sebab/alasan",
      "Berupa mashdar manshub",
      "Menjawab 'لِمَاذَا' (mengapa)"
    ],
    formula: "فَعَلَ + مَصْدَرٌ (sebab)",
    example: "قَامَ احْتِرَامًا لِلْأُسْتَاذِ",
    exampleAnalysis: [
      { word: "قَامَ", role: "Fi'il + Fa'il mustatir" },
      { word: "احْتِرَامًا", role: "Maf'ul Li'ajlih (manshub)" },
      { word: "لِلْأُسْتَاذِ", role: "Jar Majrur" }
    ],
    translation: "Dia berdiri karena menghormati guru.",
    color: "orange",
    relatedTerms: ["maful_mutlaq", "mashdar"]
  },

  // ============================================
  // KATEGORI: MAJRURAT
  // ============================================
  {
    id: "isim_majrur",
    category: "Majrurat",
    arabic: "اِسْمٌ مَجْرُورٌ",
    latin: "Ismun Majrūr",
    title: "Isim Majrur",
    level: "Dasar",
    tags: ["jar majrur", "majrur", "kasrah"],
    description: "Isim yang mendapat harakat kasrah karena didahului oleh harf jar.",
    characteristics: [
      "Didahului harf jar",
      "Berharakat kasrah",
      "Membentuk frasa jar majrur"
    ],
    formula: "حَرْفُ جَرٍّ + اِسْمٌ مَجْرُورٌ",
    example: "فِي الْمَسْجِدِ",
    exampleAnalysis: [
      { word: "فِي", role: "Harf Jar" },
      { word: "الْمَسْجِدِ", role: "Isim Majrur (kasrah)" }
    ],
    translation: "Di dalam masjid.",
    color: "purple",
    relatedTerms: ["harf_jar", "mudhaf_ilaih"]
  },

  {
    id: "mudhaf_ilaih",
    category: "Majrurat",
    arabic: "مُضَافٌ إِلَيْهِ",
    latin: "Muḍāfun Ilaih",
    title: "Mudhaf Ilaih",
    level: "Dasar",
    tags: ["idafah", "kepemilikan", "majrur"],
    description: "Isim yang menjadi pemilik dalam susunan idhafah. Mudhaf ilaih selalu majrur (berharakat kasrah).",
    characteristics: [
      "Menunjukkan pemilik",
      "Selalu majrur",
      "Terletak setelah mudhaf"
    ],
    formula: "مُضَافٌ + مُضَافٌ إِلَيْهِ (majrur)",
    example: "كِتَابُ الطَّالِبِ",
    exampleAnalysis: [
      { word: "كِتَابُ", role: "Mudhaf" },
      { word: "الطَّالِبِ", role: "Mudhaf Ilaih (majrur)" }
    ],
    translation: "Buku siswa.",
    color: "purple",
    relatedTerms: ["mudhaf", "isim_majrur"]
  },

  // ============================================
  // KATEGORI: HURUF
  // ============================================
  {
    id: "harf_jar",
    category: "Huruf",
    arabic: "حَرْفُ جَرٍّ",
    latin: "Ḥarfu Jarr",
    title: "Harf Jar",
    level: "Dasar",
    tags: ["huruf", "preposisi", "jar"],
    description: "Huruf yang menyebabkan isim setelahnya menjadi majrur (umumnya berharakat kasrah).",
    characteristics: [
      "Membuat isim sesudahnya majrur",
      "Ada 21 huruf jar",
      "Yang populer: مِنْ إِلَى فِي عَلَى عَنْ بِ لِ"
    ],
    formula: "حَرْفُ جَرٍّ + اِسْمٌ → مَجْرُورٌ",
    example: "ذَهَبْتُ إِلَى الْمَدْرَسَةِ",
    exampleAnalysis: [
      { word: "ذَهَبْتُ", role: "Fi'il + Fa'il" },
      { word: "إِلَى", role: "Harf Jar" },
      { word: "الْمَدْرَسَةِ", role: "Isim Majrur" }
    ],
    translation: "Aku pergi ke sekolah.",
    color: "slate",
    additionalInfo: {
      hurufJar: [
        { huruf: "مِنْ", arti: "dari" },
        { huruf: "إِلَى", arti: "ke" },
        { huruf: "فِي", arti: "di/dalam" },
        { huruf: "عَلَى", arti: "di atas" },
        { huruf: "عَنْ", arti: "dari/tentang" },
        { huruf: "بِ", arti: "dengan" },
        { huruf: "لِ", arti: "untuk" },
        { huruf: "كَ", arti: "seperti" },
        { huruf: "حَتَّى", arti: "hingga" },
        { huruf: "رُبَّ", arti: "banyak/sedikit" }
      ]
    },
    relatedTerms: ["isim_majrur", "mudhaf_ilaih"]
  },

  {
    id: "harf_athaf",
    category: "Huruf",
    arabic: "حَرْفُ عَطْفٍ",
    latin: "Ḥarfu 'Aṭf",
    title: "Harf 'Athaf",
    level: "Dasar",
    tags: ["huruf", "konjungsi", "athaf"],
    description: "Huruf yang menyambungkan dua kata atau kalimat. Ma'thuf (yang disambung) mengikuti i'rab ma'thuf 'alaih (yang disambungi).",
    characteristics: [
      "Menyambungkan kata/kalimat",
      "Ma'thuf mengikuti i'rab ma'thuf 'alaih",
      "Yang populer: وَ فَ ثُمَّ أَوْ"
    ],
    formula: "مَعْطُوفٌ عَلَيْهِ + حَرْفُ عَطْفٍ + مَعْطُوفٌ",
    example: "جَاءَ مُحَمَّدٌ وَعَلِيٌّ",
    exampleAnalysis: [
      { word: "جَاءَ", role: "Fi'il" },
      { word: "مُحَمَّدٌ", role: "Fa'il (marfu')" },
      { word: "وَ", role: "Harf 'Athaf" },
      { word: "عَلِيٌّ", role: "Ma'thuf (marfu' - mengikuti)" }
    ],
    translation: "Muhammad dan Ali datang.",
    color: "slate",
    additionalInfo: {
      hurufAthaf: [
        { huruf: "وَ", arti: "dan", makna: "menggabungkan" },
        { huruf: "فَ", arti: "maka/lalu", makna: "urutan langsung" },
        { huruf: "ثُمَّ", arti: "kemudian", makna: "urutan dengan jarak" },
        { huruf: "أَوْ", arti: "atau", makna: "pilihan" },
        { huruf: "بَلْ", arti: "bahkan", makna: "penggantian" },
        { huruf: "لٰكِنْ", arti: "tetapi", makna: "pertentangan" }
      ]
    },
    relatedTerms: ["mathuf", "mathuf_alaih"]
  },

  {
    id: "huruf_nashab",
    category: "Huruf",
    arabic: "حُرُوفُ النَّصْبِ",
    latin: "Ḥurūfun Naṣb",
    title: "Huruf Nashab",
    level: "Menengah",
    tags: ["huruf", "nashab", "fi'il mudhari"],
    description: "Huruf yang membuat fi'il mudhari' menjadi manshub. Yang paling populer: أَنْ لَنْ كَيْ",
    characteristics: [
      "Membuat mudhari' manshub",
      "Mengubah makna fi'il",
      "Tanda nashab: fathah (untuk fi'il shahih)"
    ],
    formula: "حَرْفُ نَصْبٍ + فِعْلٌ مُضَارِعٌ → manshub",
    example: "أُرِيدُ أَنْ أَدْرُسَ",
    exampleAnalysis: [
      { word: "أُرِيدُ", role: "Fi'il Mudhari'" },
      { word: "أَنْ", role: "Harf Nashab" },
      { word: "أَدْرُسَ", role: "Fi'il Mudhari' Manshub" }
    ],
    translation: "Aku ingin belajar.",
    color: "slate",
    additionalInfo: {
      hurufNashab: [
        { huruf: "أَنْ", arti: "bahwa/untuk" },
        { huruf: "لَنْ", arti: "tidak akan" },
        { huruf: "كَيْ", arti: "agar/supaya" },
        { huruf: "إِذَنْ", arti: "kalau begitu" }
      ]
    },
    relatedTerms: ["fiil_mudhari", "huruf_jazm"]
  },

  {
    id: "huruf_jazm",
    category: "Huruf",
    arabic: "حُرُوفُ الْجَزْمِ",
    latin: "Ḥurūful Jazm",
    title: "Huruf Jazm",
    level: "Menengah",
    tags: ["huruf", "jazm", "sukun"],
    description: "Huruf yang membuat fi'il mudhari' menjadi majzum (berharakat sukun). Yang populer: لَمْ لَمَّا لَا النَّاهِيَةُ",
    characteristics: [
      "Membuat mudhari' majzum",
      "Tanda jazm: sukun (untuk shahih)",
      "Mengubah waktu/makna fi'il"
    ],
    formula: "حَرْفُ جَزْمٍ + فِعْلٌ مُضَارِعٌ → majzum",
    example: "لَمْ يَذْهَبْ",
    exampleAnalysis: [
      { word: "لَمْ", role: "Harf Jazm" },
      { word: "يَذْهَبْ", role: "Fi'il Mudhari' Majzum (sukun)" }
    ],
    translation: "Dia tidak pergi.",
    color: "slate",
    additionalInfo: {
      hurufJazm: [
        { huruf: "لَمْ", arti: "tidak (lampau)" },
        { huruf: "لَمَّا", arti: "belum" },
        { huruf: "لَا النَّاهِيَةُ", arti: "jangan" },
        { huruf: "لَامُ الْأَمْرِ", arti: "hendaklah" }
      ]
    },
    relatedTerms: ["fiil_mudhari", "huruf_nashab"]
  },

  // ============================================
  // KATEGORI: TAWABI' (PENGIKUT)
  // ============================================
  {
    id: "naat",
    category: "Tawabi'",
    arabic: "نَعْتٌ",
    latin: "Na't",
    title: "Na'at (Sifat)",
    level: "Dasar",
    tags: ["sifat", "adjektif", "tawabi"],
    description: "Kata sifat yang mengikuti kata yang disifati (man'ut) dalam 10 hal: i'rab, ma'rifah/nakirah, mufrad/tatsniyah/jama', mudzakkar/muannats.",
    characteristics: [
      "Menerangkan sifat",
      "Mengikuti man'ut dalam 10 hal",
      "Dapat berupa isim atau jumlah"
    ],
    formula: "مَنْعُوتٌ + نَعْتٌ (mengikuti)",
    example: "جَاءَ رَجُلٌ كَرِيمٌ",
    exampleAnalysis: [
      { word: "جَاءَ", role: "Fi'il" },
      { word: "رَجُلٌ", role: "Fa'il (man'ut)" },
      { word: "كَرِيمٌ", role: "Na'at (mengikuti: marfu', nakirah, mufrad, mudzakkar)" }
    ],
    translation: "Seorang laki-laki yang mulia datang.",
    color: "indigo",
    relatedTerms: ["mathuf", "taukid", "badal"]
  },

  {
    id: "taukid",
    category: "Tawabi'",
    arabic: "تَوْكِيدٌ",
    latin: "Taukīd",
    title: "Taukid (Penegas)",
    level: "Menengah",
    tags: ["penegas", "tawabi"],
    description: "Kata yang digunakan untuk menguatkan atau menegaskan kata sebelumnya. Ada dua jenis: taukid lafzhi (mengulang kata) dan taukid ma'nawi (dengan kata tertentu).",
    characteristics: [
      "Menguatkan makna",
      "Mengikuti i'rab mu'akkad",
      "Ada lafzhi dan ma'nawi"
    ],
    formula: "مُؤَكَّدٌ + تَوْكِيدٌ",
    example: "جَاءَ الْأُسْتَاذُ نَفْسُهُ",
    exampleAnalysis: [
      { word: "جَاءَ", role: "Fi'il" },
      { word: "الْأُسْتَاذُ", role: "Fa'il (mu'akkad)" },
      { word: "نَفْسُهُ", role: "Taukid ma'nawi (marfu' - mengikuti)" }
    ],
    translation: "Guru itu sendiri datang.",
    color: "indigo",
    additionalInfo: {
      "taukidMa'nawi": ["نَفْسٌ", "عَيْنٌ", "كِلَا", "كِلْتَا", "كُلٌّ", "أَجْمَعُ"]
    },
    relatedTerms: ["naat", "badal"]
  },

  {
    id: "badal",
    category: "Tawabi'",
    arabic: "بَدَلٌ",
    latin: "Badal",
    title: "Badal (Pengganti)",
    level: "Lanjutan",
    tags: ["pengganti", "tawabi"],
    description: "Kata yang menggantikan kata sebelumnya (mubdal minhu) dalam makna. Badal mengikuti i'rab mubdal minhu.",
    characteristics: [
      "Menggantikan kata sebelumnya",
      "Mengikuti i'rab mubdal minhu",
      "Ada 4 jenis badal"
    ],
    formula: "مُبْدَلٌ مِنْهُ + بَدَلٌ",
    example: "جَاءَ أَخُوكَ مُحَمَّدٌ",
    exampleAnalysis: [
      { word: "جَاءَ", role: "Fi'il" },
      { word: "أَخُوكَ", role: "Fa'il (mubdal minhu)" },
      { word: "مُحَمَّدٌ", role: "Badal (marfu' - mengikuti)" }
    ],
    translation: "Saudaramu, (yaitu) Muhammad, datang.",
    color: "indigo",
    additionalInfo: {
      jenisBadal: [
        "بَدَلُ الْكُلِّ مِنَ الْكُلِّ (seluruh dari seluruh)",
        "بَدَلُ الْبَعْضِ مِنَ الْكُلِّ (sebagian dari seluruh)",
        "بَدَلُ الِاشْتِمَالِ (yang berkaitan)",
        "بَدَلُ الْغَلَطِ (pengganti kesalahan)"
      ]
    },
    relatedTerms: ["naat", "mathuf"]
  },

  // ============================================
  // KATEGORI: KONSEP DASAR
  // ============================================
  {
    id: "jumlah_ismiyyah",
    category: "Konsep Dasar",
    arabic: "الْجُمْلَةُ الِاسْمِيَّةُ",
    latin: "Al-Jumlatul Ismiyyah",
    title: "Jumlah Ismiyyah",
    level: "Dasar",
    tags: ["kalimat", "nominal", "mubtada khabar"],
    description: "Kalimat yang diawali dengan isim (mubtada'). Terdiri dari mubtada' (subjek) dan khabar (predikat), keduanya marfu'.",
    characteristics: [
      "Diawali isim (mubtada')",
      "Minimal: mubtada' + khabar",
      "Keduanya marfu'"
    ],
    formula: "مُبْتَدَأٌ (marfu') + خَبَرٌ (marfu')",
    example: "اللَّهُ رَبُّنَا",
    exampleAnalysis: [
      { word: "اللَّهُ", role: "Mubtada' (marfu')" },
      { word: "رَبُّنَا", role: "Khabar (marfu')" }
    ],
    translation: "Allah adalah Tuhan kami.",
    color: "teal",
    relatedTerms: ["mubtada", "khabar", "jumlah_filiyyah"]
  },

  {
    id: "jumlah_filiyyah",
    category: "Konsep Dasar",
    arabic: "الْجُمْلَةُ الْفِعْلِيَّةُ",
    latin: "Al-Jumlatul Fi'liyyah",
    title: "Jumlah Fi'liyyah",
    level: "Dasar",
    tags: ["kalimat", "verbal", "fiil fail"],
    description: "Kalimat yang diawali dengan fi'il. Terdiri dari fi'il dan fa'il (minimal), dapat ditambah maf'ul.",
    characteristics: [
      "Diawali fi'il",
      "Minimal: fi'il + fa'il",
      "Fa'il selalu marfu'"
    ],
    formula: "فِعْلٌ + فَاعِلٌ (marfu') + [مَفْعُولٌ]",
    example: "قَرَأَ الطَّالِبُ الْكِتَابَ",
    exampleAnalysis: [
      { word: "قَرَأَ", role: "Fi'il Madhi" },
      { word: "الطَّالِبُ", role: "Fa'il (marfu')" },
      { word: "الْكِتَابَ", role: "Maf'ul Bih (manshub)" }
    ],
    translation: "Siswa membaca buku.",
    color: "teal",
    relatedTerms: ["fiil_madhi", "fail", "jumlah_ismiyyah"]
  },

  {
    id: "mudhaf",
    category: "Konsep Dasar",
    arabic: "مُضَافٌ",
    latin: "Muḍāf",
    title: "Mudhaf",
    level: "Dasar",
    tags: ["idafah", "susunan"],
    description: "Isim pertama dalam susunan idhafah yang kehilangan tanwin atau 'alif-lam'. Mudhaf tidak boleh bertanwin.",
    characteristics: [
      "Tidak bertanwin",
      "Tidak ber-alif-lam",
      "Diikuti mudhaf ilaih"
    ],
    formula: "مُضَافٌ (tanpa tanwin) + مُضَافٌ إِلَيْهِ (majrur)",
    example: "كِتَابُ الطَّالِبِ",
    exampleAnalysis: [
      { word: "كِتَابُ", role: "Mudhaf (tidak ada tanwin)" },
      { word: "الطَّالِبِ", role: "Mudhaf Ilaih (majrur)" }
    ],
    translation: "Buku siswa.",
    color: "teal",
    relatedTerms: ["mudhaf_ilaih", "isim_majrur"]
  },

  {
    id: "isim",
    category: "Konsep Dasar",
    arabic: "اِسْمٌ",
    latin: "Ism",
    title: "Isim (Kata Benda)",
    level: "Dasar",
    tags: ["kata benda", "noun"],
    description: "Kata yang menunjukkan nama orang, tempat, benda, sifat, atau makna yang tidak terikat waktu. Isim dapat berubah i'rabnya (mu'rab).",
    characteristics: [
      "Menunjukkan nama/benda/sifat",
      "Tidak terikat waktu",
      "Dapat ber-tanwin, ber-alif-lam, atau jarr"
    ],
    formula: "Ciri: tanwin (ٌ ٍ ً), al (ال), atau masuk jar/nashab/rafa'",
    example: "مُحَمَّدٌ طَالِبٌ مُجْتَهِدٌ",
    exampleAnalysis: [
      { word: "مُحَمَّدٌ", role: "Isim (mubtada')" },
      { word: "طَالِبٌ", role: "Isim (khabar)" },
      { word: "مُجْتَهِدٌ", role: "Isim (na'at)" }
    ],
    translation: "Muhammad adalah siswa yang rajin.",
    color: "teal",
    relatedTerms: ["fiil", "harf"]
  },

  {
    id: "fiil",
    category: "Konsep Dasar",
    arabic: "فِعْلٌ",
    latin: "Fi'l",
    title: "Fi'il (Kata Kerja)",
    level: "Dasar",
    tags: ["kata kerja", "verb", "waktu"],
    description: "Kata yang menunjukkan pekerjaan/peristiwa yang terikat dengan waktu (lampau, sekarang, atau perintah).",
    characteristics: [
      "Menunjukkan pekerjaan",
      "Terikat waktu",
      "Ada 3 jenis: madhi, mudhari', amr"
    ],
    formula: "قَدْ / سَ / سَوْفَ / تَاءُ التَّأْنِيثِ (ciri fi'il)",
    example: "كَتَبَ - يَكْتُبُ - اُكْتُبْ",
    exampleAnalysis: [
      { word: "كَتَبَ", role: "Fi'il Madhi" },
      { word: "يَكْتُبُ", role: "Fi'il Mudhari'" },
      { word: "اُكْتُبْ", role: "Fi'il Amr" }
    ],
    translation: "Menulis (lampau - sekarang - perintah).",
    color: "teal",
    relatedTerms: ["fiil_madhi", "fiil_mudhari", "fiil_amr"]
  },

  {
    id: "harf",
    category: "Konsep Dasar",
    arabic: "حَرْفٌ",
    latin: "Ḥarf",
    title: "Harf (Kata Partikel)",
    level: "Dasar",
    tags: ["partikel", "huruf"],
    description: "Kata yang tidak memiliki makna kecuali jika digabung dengan kata lain (isim atau fi'il). Harf tidak dapat berdiri sendiri.",
    characteristics: [
      "Tidak bermakna mandiri",
      "Mempengaruhi kata sesudahnya",
      "Tidak dapat di-i'rab"
    ],
    formula: "Contoh: فِي، مِنْ، إِلَى، لَمْ، قَدْ",
    example: "ذَهَبَ إِلَى الْمَسْجِدِ",
    exampleAnalysis: [
      { word: "ذَهَبَ", role: "Fi'il" },
      { word: "إِلَى", role: "Harf (jar)" },
      { word: "الْمَسْجِدِ", role: "Isim majrur" }
    ],
    translation: "Dia pergi ke masjid.",
    color: "teal",
    relatedTerms: ["harf_jar", "harf_athaf", "huruf_nashab"]
  }
];

// Export utility functions
export const getDictionaryById = (id) => {
  return NAHWU_DICTIONARY.find(item => item.id === id);
};

export const getDictionaryByCategory = (category) => {
  return NAHWU_DICTIONARY.filter(item => item.category === category);
};

export const searchDictionary = (query) => {
  const lowerQuery = query.toLowerCase();
  return NAHWU_DICTIONARY.filter(item => 
    item.title.toLowerCase().includes(lowerQuery) ||
    item.arabic.includes(query) ||
    item.latin.toLowerCase().includes(lowerQuery) ||
    item.description.toLowerCase().includes(lowerQuery) ||
    item.tags.some(tag => tag.includes(lowerQuery))
  );
};

export const getCategories = () => {
  return [...new Set(NAHWU_DICTIONARY.map(item => item.category))];
};

export const getDictionaryByLevel = (level) => {
  return NAHWU_DICTIONARY.filter(item => item.level === level);
};